// src/modules/app-views/leads/components/CardHeaderLeadsCol1.jsx
// *******************************************************************************
// CARD HEADER: Document Code, Created At, Updated At
// *******************************************************************************
// Column 1 of the leads document card header.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleColumn from 'components/SimpleComponents/SimpleColumn';
import { documentCodeItem } from 'layouts/Pages/PageHeader/CardHeaderColumn/items/documentCode';
import { createdAtItem } from 'layouts/Pages/PageHeader/CardHeaderColumn/items/createdAt';
import { updatedAtItem } from 'layouts/Pages/PageHeader/CardHeaderColumn/items/updatedAt';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CardHeaderLeadsCol1 = ({ forceShow = false, ...record }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const items = [
    documentCodeItem(record),
    createdAtItem(record),
    updatedAtItem(record),
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <SimpleColumn items={items.filter(i => i?.label || forceShow)} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderLeadsCol1;
